<div class="user-avatar">
    <div class="user-avatar-actions" (click)="toggle()">
      <!-- <span *ngIf="user">{{ user?.first_name + ' ' + user?.last_name }}</span> -->
        <div class="d-inline-block">
          <span *ngIf="user" class="user-avatar__name">{{ user?.first_name + ' ' + user?.last_name }}</span>
        </div>
        <i class="bi" [ngClass]="clicked ? 'bi-caret-up-fill' : 'bi-caret-down-fill'"></i>
    </div>
    <div class="user-avatar-menu" *ngIf="clicked">
        <p class="user-avatar-menu-wellcome">¡Hola, bienvenida!</p>
        <ul class="user-avatar-menu-list">
            <li class="user-avatar-menu-item head">
                <span>Portal</span>
            </li>
            <li class="user-avatar-menu-item">
                <a [routerLink]="['/mis-cursos']">
                    <i class="bi bi-card-list"></i>Mis cursos
                </a>
            </li>
            <li class="user-avatar-menu-item" *ngIf="showEnrollment">
                <a [routerLink]="['/matricula']">
                    <i class="bi bi-calendar2-plus-fill"></i>Matr&iacute;cula
                </a>
            </li>
        </ul>
        <div class="user-avatar-menu-closesession">
            <span (click)="closeSession()">Cerrar Sesi&oacute;n</span>
        </div>
    </div>
</div>
